export const translations = {
  pt: {
    nav: {
      teacher: "Professor",
      courses: "Aulas",
      levels: "Níveis",
      testimonials: "Depoimentos",
      contact: "Contato",
      cta: "Aula grátis",
    },
    hero: {
      overline: "Aulas de francês online · 1ª aula grátis",
      title: ["Comece com uma", "aula grátis", "de francês online."],
      subtitle:
        "Aulas particulares e em pequenos grupos, online, para brasileiros de todas as idades e níveis — do iniciante curioso ao candidato TEF, TCF, DELF e DALF.",
      ctaPrimary: "Reserve já minha aula grátis",
      ctaSecondary: "Conhecer o método",
      meta: ["Particular ou em dupla/trio", "Todos os níveis", "TEF · TCF · DELF · DALF · Conversação"],
      conversion: {
        badge: "1ª aula grátis · sem compromisso",
        title: "Reserve sua aula em 30 segundos.",
        seoH2: "Oferta inicial · primeira aula grátis",
        subtitle: "Sem cartão, sem pegadinha. Resposta em até 24 h.",
        primary: "Quero minha aula grátis",
        notReady: "Ainda não está pronto?",
        secondary: "Faça o teste de nível grátis em 5 min",
        trust: ["20 anos no Rio", "100% online", "Do A1 ao C2"],
      },
    },
    teacher: {
      overline: "Quem ensina",
      seoH2: "Sobre o professor",
      name: "Professor Lionel",
      title: "Nascido e criado em Paris.",
      body: [
        "Bonjour ! Eu sou Lionel — alguns me chamam de « M. Bonjour-merci » — professor de francês nativo de Paris. Há anos ajudo brasileiros e brasileiras a se apaixonarem pela minha língua materna — com método, paciência e muita conversa.",
        "Minhas aulas são feitas sob medida: seja para sua próxima viagem à França, para passar no TCF/DELF/DALF, ou simplesmente para conversar sem medo. Falamos francês desde o primeiro minuto, no seu ritmo.",
      ],
      stats: [
        { value: "100%", label: "online" },
        { value: "1ª", label: "aula grátis" },
        { value: "FR", label: "nativo de Paris" },
      ],
    },
    offerings: {
      overline: "Como podemos estudar",
      seoH2: "Modalidades · aulas online",
      title: "Um curso para cada motivo de aprender francês.",
      items: [
        {
          tag: "01",
          title: "Aulas particulares",
          body: "Plano totalmente personalizado, foco no seu objetivo e no seu ritmo. Você no centro da aula.",
        },
        {
          tag: "02",
          title: "Pequenos grupos",
          body: "Em dupla ou trio, com amigos ou família. Mais leve, mais econômico — e muita conversa em francês.",
        },
        {
          tag: "03",
          title: "Provas oficiais",
          body: "Preparação dedicada para TEF, TCF, DELF e DALF: estratégia, simulados e correção detalhada.",
        },
        {
          tag: "04",
          title: "Viagem & cultura",
          body: "Francês prático para sua viagem, com mergulho na cultura, no cinema e na vida parisiense.",
        },
        {
          tag: "05",
          title: "Conversação",
          body: "Solte a língua. Aulas dinâmicas, temas atuais e correção amigável para você falar com confiança.",
        },
        {
          tag: "06",
          title: "Todas as idades",
          body: "Crianças, adolescentes e adultos. Material e abordagem ajustados a cada fase da vida.",
        },
      ],
    },
    testimonials: {
      overline: "Depoimentos",
      seoH2: "Benefícios e depoimentos de alunos",
      title: "Histórias de quem destravou o francês.",
      items: [
        {
          quote:
            "Sempre travei na hora de falar. Em 3 meses com o Lionel, fiz check-in em Paris inteira em francês. Método humano e muito claro.",
          name: "Mariana Lopes",
          role: "Designer · São Paulo",
        },
        {
          quote:
            "Sou apaixonado pela língua francesa e quero ler os clássicos no original. Já falava, mas com o Lionel estou me aperfeiçoando para passar um mês inteiro viajando pela França.",
          name: "Rafael Andrade",
          role: "Apaixonado pela França · Belo Horizonte",
        },
        {
          quote:
            "Estudei com o Lionel para o DELF B2 e passei! Hoje curso a faculdade na Université de Montpellier — sem a preparação dele, não teria conseguido.",
          name: "Lucas Almeida",
          role: "Estudante · Rio de Janeiro → Montpellier",
        },
        {
          quote:
            "Estudei francês a vida inteira e nunca soltei a língua. Em pequeno grupo com o Lionel, finalmente perdi o medo.",
          name: "Cláudio Ribeiro",
          role: "Aposentado · Florianópolis",
        },
      ],
    },
    contact: {
      overline: "Sua primeira aula",
      seoH2: "Contato · reserve sua primeira aula",
      title: "Reserve sua aula gratuita.",
      subtitle:
        "Conte um pouco sobre você e o motivo de aprender francês. O Professor Lionel responde em até 24 horas.",
      labels: {
        name: "Nome completo",
        preferredName: "Como prefere ser chamado(a)? (opcional)",
        email: "E-mail",
        phone: "WhatsApp (opcional)",
        level: "Seu nível atual",
        interest: "Objetivo principal",
        message: "Mensagem (opcional)",
      },
      levels: ["Iniciante", "Intermediário", "Avançado", "Ainda não sei"],
      interests: [
        "Conversação",
        "Viagem",
        "TEF / TCF / DELF / DALF",
        "Aula para criança",
        "Aula em grupo",
        "Outro",
      ],
      submit: "Quero minha aula grátis",
      submitting: "Enviando…",
      success: "Recebido! O Professor Lionel vai te responder em breve.",
      successWithName: "Combinado, {name}! Lionel te responde em até 24h.",
      error: "Algo deu errado. Tente novamente ou fale no WhatsApp.",
      whatsapp: "Falar no WhatsApp",
    },
    footer: {
      tagline: "Aulas de francês online com um parisiense da gema.",
      links: "Navegar",
      contact: "Contato",
      rights: "Todos os direitos reservados.",
      privacy: "Política de Privacidade",
    },
    brandSubtitle: "Prof Lionel · 20 anos de experiência no Rio de Janeiro",
    lang: { pt: "Português", en: "English", fr: "Français" },
  },
  en: {
    nav: {
      teacher: "Teacher",
      courses: "Lessons",
      levels: "Levels",
      testimonials: "Testimonials",
      contact: "Contact",
      cta: "Free lesson",
    },
    hero: {
      overline: "Online French lessons · 1st lesson free",
      title: ["Start with a", "free French", "class online."],
      subtitle:
        "Private and small-group online lessons for learners of all ages and levels — from curious beginners to TEF, TCF, DELF and DALF candidates.",
      ctaPrimary: "Book my free lesson now",
      ctaSecondary: "Discover the method",
      meta: ["Private or duo/trio", "All levels", "TEF · TCF · DELF · DALF · Conversation"],
      conversion: {
        badge: "1st class free · no commitment",
        title: "Book your class in 30 seconds.",
        seoH2: "Initial offer · first lesson free",
        subtitle: "No card, no catch. Reply within 24 h.",
        primary: "I want my free class",
        notReady: "Not ready yet?",
        secondary: "Take the free 5-min level test",
        trust: ["20 years in Rio", "100% online", "A1 to C2"],
      },
    },
    teacher: {
      overline: "Your teacher",
      seoH2: "About the teacher",
      name: "Professor Lionel",
      title: "Born and raised in Paris.",
      body: [
        "Bonjour! I'm Lionel — some call me « M. Bonjour-merci » — a French teacher and native Parisian. For years, I've been helping students from Brazil and beyond fall in love with my mother tongue — with method, patience, and a lot of conversation.",
        "My classes are tailor-made: for your next trip to France, to pass TCF/DELF/DALF, or simply to chat without fear. We speak French from the very first minute, at your own pace.",
      ],
      stats: [
        { value: "100%", label: "online" },
        { value: "1st", label: "lesson free" },
        { value: "FR", label: "native Parisian" },
      ],
    },
    offerings: {
      overline: "How we can study",
      seoH2: "Class formats · online lessons",
      title: "A course for every reason to learn French.",
      items: [
        { tag: "01", title: "Private lessons", body: "Fully personalised plan, focused on your goal and pace." },
        { tag: "02", title: "Small groups", body: "Duo or trio with friends or family. Lighter, cheaper — more talking." },
        { tag: "03", title: "Official exams", body: "Focused prep for TEF, TCF, DELF and DALF: strategy, mocks and detailed feedback." },
        { tag: "04", title: "Travel & culture", body: "Practical French for your trip and a dive into culture, cinema and Parisian life." },
        { tag: "05", title: "Conversation", body: "Loosen your tongue. Lively classes, current topics, friendly correction." },
        { tag: "06", title: "All ages", body: "Kids, teens and adults. Material and approach tuned to each life stage." },
      ],
    },
    testimonials: {
      overline: "Testimonials",
      seoH2: "Benefits and student testimonials",
      title: "Stories from students who unlocked French.",
      items: [
        { quote: "I always froze when I had to speak. Three months with Lionel and I checked in across Paris in French. Human, very clear method.", name: "Mariana Lopes", role: "Designer · São Paulo" },
        { quote: "I'm in love with the French language and want to read the classics in the original. I already spoke, but with Lionel I'm polishing my French for a one-month trip across France.", name: "Rafael Andrade", role: "Francophile · Belo Horizonte" },
        { quote: "I studied with Lionel for the DELF B2 and passed! Today I'm a student at Université de Montpellier — without his prep, I wouldn't have made it.", name: "Lucas Almeida", role: "Student · Rio de Janeiro → Montpellier" },
        { quote: "I studied French my whole life and never spoke. In a small group with Lionel, I finally let go of the fear.", name: "Cláudio Ribeiro", role: "Retired · Florianópolis" },
      ],
    },
    contact: {
      overline: "Your first lesson",
      seoH2: "Contact · book your first lesson",
      title: "Book your free lesson.",
      subtitle: "Tell us a bit about yourself and why you want to learn French. Professor Lionel replies within 24 hours.",
      labels: {
        name: "Full name",
        preferredName: "What should I call you? (optional)",
        email: "Email",
        phone: "WhatsApp (optional)",
        level: "Your current level",
        interest: "Main goal",
        message: "Message (optional)",
      },
      levels: ["Beginner", "Intermediate", "Advanced", "Not sure yet"],
      interests: ["Conversation", "Travel", "TEF / TCF / DELF / DALF", "Children's class", "Group class", "Other"],
      submit: "Get my free lesson",
      submitting: "Sending…",
      success: "Got it! Professor Lionel will get back to you very soon.",
      error: "Something went wrong. Please try again or message on WhatsApp.",
      whatsapp: "Chat on WhatsApp",
    },
    footer: {
      tagline: "Online French lessons with a true-blue Parisian.",
      links: "Navigate",
      contact: "Contact",
      rights: "All rights reserved.",
      privacy: "Privacy Policy",
    },
    brandSubtitle: "with prof. Lionel · 20 years of experience in Rio de Janeiro",
    lang: { pt: "Português", en: "English", fr: "Français" },
  },
  fr: {
    nav: {
      teacher: "Professeur",
      courses: "Cours",
      levels: "Niveaux",
      testimonials: "Témoignages",
      contact: "Contact",
      cta: "Cours gratuit",
    },
    hero: {
      overline: "Cours de français en ligne · 1er cours offert",
      title: ["Commencez par un", "cours gratuit", "de français en ligne."],
      subtitle:
        "Cours particuliers et en petits groupes, en ligne, pour les Brésilien·ne·s de tout âge et tout niveau — du débutant curieux au candidat TEF, TCF, DELF et DALF.",
      ctaPrimary: "Réservez mon cours offert",
      ctaSecondary: "Découvrir la méthode",
      meta: ["Particulier ou duo/trio", "Tous niveaux", "TEF · TCF · DELF · DALF · Conversation"],
      conversion: {
        badge: "1er cours offert · sans engagement",
        title: "Réservez votre cours en 30 secondes.",
        seoH2: "Offre initiale · 1er cours offert",
        subtitle: "Sans CB, sans piège. Réponse sous 24 h.",
        primary: "Je veux mon cours offert",
        notReady: "Pas encore prêt ?",
        secondary: "Faites le test de niveau gratuit (5 min)",
        trust: ["20 ans à Rio", "100 % en ligne", "Du A1 au C2"],
      },
    },
    teacher: {
      overline: "Votre professeur",
      name: "Professeur Lionel",
      title: "Né et grandi à Paris.",
      body: [
        "Bonjour ! Je suis Lionel — certains m'appellent « M. Bonjour-merci » — professeur de français et Parisien d'origine. Depuis des années, j'aide les Brésilien·ne·s à tomber amoureux de ma langue maternelle — avec méthode, patience et beaucoup d'échanges.",
        "Mes cours sont sur mesure : pour votre prochain voyage en France, pour réussir le TCF/DELF/DALF, ou simplement pour discuter sans peur. On parle français dès la première minute, à votre rythme.",
      ],
      stats: [
        { value: "100%", label: "en ligne" },
        { value: "1er", label: "cours offert" },
        { value: "FR", label: "natif de Paris" },
      ],
    },
    offerings: {
      overline: "Comment apprendre",
      seoH2: "Modalités · cours en ligne",
      title: "Un cours pour chaque envie d'apprendre le français.",
      items: [
        { tag: "01", title: "Cours particuliers", body: "Plan 100 % personnalisé, centré sur votre objectif et votre rythme." },
        { tag: "02", title: "Petits groupes", body: "En duo ou trio, entre amis ou en famille. Plus léger, plus économique." },
        { tag: "03", title: "Examens officiels", body: "Préparation dédiée au TEF, TCF, DELF et DALF : stratégie, simulations et corrections détaillées." },
        { tag: "04", title: "Voyage & culture", body: "Français pratique pour votre voyage et plongée dans la culture, le cinéma et la vie parisienne." },
        { tag: "05", title: "Conversation", body: "Libérez votre parole. Cours dynamiques, sujets actuels, correction bienveillante." },
        { tag: "06", title: "Tous les âges", body: "Enfants, ados et adultes. Méthode adaptée à chaque étape de la vie." },
      ],
    },
    testimonials: {
      overline: "Témoignages",
      seoH2: "Bénéfices et témoignages d'élèves",
      title: "Des élèves qui ont enfin libéré leur français.",
      items: [
        { quote: "Je restais bloquée pour parler. Trois mois avec Lionel et j'ai tout fait en français à Paris. Méthode très claire et humaine.", name: "Mariana Lopes", role: "Designer · São Paulo" },
        { quote: "Je suis passionné par la langue française et je veux lire les classiques en V.O. Je parlais déjà, mais avec Lionel je me perfectionne pour un mois entier de voyage en France.", name: "Rafael Andrade", role: "Francophile · Belo Horizonte" },
        { quote: "J'ai préparé le DELF B2 avec Lionel et je l'ai réussi ! Aujourd'hui j'étudie à l'Université de Montpellier — sans sa préparation, je n'y serais pas arrivé.", name: "Lucas Almeida", role: "Étudiant · Rio de Janeiro → Montpellier" },
        { quote: "J'ai étudié le français toute ma vie sans jamais parler. En petit groupe avec Lionel, j'ai enfin osé.", name: "Cláudio Ribeiro", role: "Retraité · Florianópolis" },
      ],
    },
    contact: {
      overline: "Votre premier cours",
      seoH2: "Contact · réservez votre premier cours",
      title: "Réservez votre cours offert.",
      subtitle: "Parlez-nous un peu de vous et de votre motivation. Le Professeur Lionel répond sous 24 heures.",
      labels: {
        name: "Nom complet",
        preferredName: "Comment dois-je vous appeler ? (optionnel)",
        email: "E-mail",
        phone: "WhatsApp (optionnel)",
        level: "Votre niveau actuel",
        interest: "Objectif principal",
        message: "Message (optionnel)",
      },
      levels: ["Débutant", "Intermédiaire", "Avancé", "Je ne sais pas encore"],
      interests: ["Conversation", "Voyage", "TEF / TCF / DELF / DALF", "Cours pour enfant", "Cours en groupe", "Autre"],
      submit: "Je veux mon cours offert",
      submitting: "Envoi…",
      success: "Reçu ! Le Professeur Lionel vous répondra très vite.",
      successWithName: "C'est noté, {name} ! Lionel vous répond sous 24h.",
      error: "Une erreur est survenue. Réessayez ou écrivez sur WhatsApp.",
      whatsapp: "Écrire sur WhatsApp",
    },
    footer: {
      tagline: "Cours de français en ligne avec un vrai parigot.",
      links: "Navigation",
      contact: "Contact",
      rights: "Tous droits réservés.",
      privacy: "Politique de confidentialité",
    },
    brandSubtitle: "Prof Lionel · 20 ans d'expérience à Rio de Janeiro",
    lang: { pt: "Português", en: "English", fr: "Français" },
  },
};

export const SUPPORTED_LANGUAGES = ["pt", "en", "fr"];
